export const SET_STEP = "SET_STEP@Stepper";
export const INCREMENT_STEP = "INCREMENT_STEP@Stepper";
export const DECREMENT_STEP = "DECREMENT_STEP@Stepper";
export const SET_SELECTED_SOURCES = "SET_SELECTED_SOURCES@Stepper";
export const SET_SELECTED_TABLES = "SET_SELECTED_TABLES@Stepper";
export const SET_SELECTED_FOLDERS = "SET_SELECTED_FOLDERS@Stepper";
export const SET_CSV_FILES = "SET_CSV_FILES@Stepper"; 